import { on } from '@ember/modifier';
import { service } from '@ember/service';
import type { SafeString } from '@ember/template';

import type { PopupData, Service } from 'webapp-types';
import { getSafeBackgroundColorStyle } from 'webapp/utils/common';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class BillingPromotionsGrowth2024PopupTrialStartedComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('billing') declare billingService: Service.Billing;
	@service('flow/promotions')
	declare flowPromotionsService: Service.Flow.Promotions;

	get isProfessional() {
		return this.billingService.activePlan?.isProfessional;
	}

	get promotion() {
		return this.flowPromotionsService.promotions.growthFeatureTrialActivePromotion;
	}

	get formattedActiveUntil() {
		return this.promotion?.formattedActiveUntilMMMDo;
	}

	get features(): { icon: IconName; bgColor: SafeString; title: string }[] {
		return [
			{
				icon: 'AiSummary',
				bgColor: getSafeBackgroundColorStyle('yellow'),
				title: 'AI summaries',
			},
			{
				icon: 'Reports',
				bgColor: getSafeBackgroundColorStyle('orange'),
				title: 'Advanced reporting',
			},
		];
	}
	<template>
		<div class="content">
			<img
				class="promo-image"
				src="/images/billing/promotions/growth-2024.png"
				alt="Upgrade promo"
			/>

			<h4>USE GROWTH PLAN FEATURES FOR FREE</h4>

			<h3>Unlock your full potential with Growth plan</h3>

			<p>
				<b>
					We’ve unlocked all Growth plan features for free
					{{#if this.formattedActiveUntil}}
						until
						{{this.formattedActiveUntil}}
					{{/if}}!
				</b>
			</p>
			<p>Don’t just visualize your performance, improve it, with powerful features like:</p>

			<div class="features">
				{{#each this.features as |feature|}}
					<div class="feature">
						<div class="feature__image" style={{feature.bgColor}}>
							<CommonUiIconComponent @name={{feature.icon}} @size="xl" />
						</div>
						<span class="feature__title">{{feature.title}}</span>
					</div>

				{{/each}}
			</div>

			{{#unless this.isProfessional}}
				<p>
					We’re giving you the opportunity to explore these Growth plan features for free
					{{#if this.formattedActiveUntil}}
						until
						{{this.formattedActiveUntil}}
					{{/if}}
					- no commitment required!
				</p>
			{{/unless}}

			<div class="footer">
				<a role="button" class="button size-big" {{on "click" this.close}}>
					Let’s try it out!
				</a>
			</div>
		</div>
	</template>
}
